import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/useAuth.js';
import { aiUsageSummary } from '../lib/callables.js';
import { AUTH_MODE } from '../auth/firebase.js';

export default function AiAllowance({ packId, kind = 'chat' }) {
    const { currentUser } = useAuth();
    const [usage, setUsage] = useState(null);
    useEffect(() => {
        setUsage(null);
        if (!currentUser || AUTH_MODE === 'mock') return;
        let live = true;
        const refresh = () => aiUsageSummary(packId ? { packId } : {}).then(data => { if (live) setUsage(data); }).catch(() => { if (live) setUsage(null); });
        refresh();
        window.addEventListener('btl-ai-usage', refresh); window.addEventListener('focus', refresh);
        return () => { live = false; window.removeEventListener('btl-ai-usage', refresh); window.removeEventListener('focus', refresh); };
    }, [currentUser?.uid, packId]);
    const data = usage?.[kind];
    if (!data || new Date(usage.resetsAt).getTime() <= Date.now()) return null;
    return <details className="my-2 text-xs text-book-muted">
        <summary className="cursor-pointer">{data.remaining <= 0 ? (data.trial ? 'Free trial allowance used' : 'Daily AI allowance used') : `About ${data.tokens.remainingPercent}% AI processing budget left`}</summary>
        <p className="mt-1">{data.remaining}/{data.limit} {data.trial ? 'free trial marks remain (lifetime).' : kind === 'chat' ? 'questions remain today.' : 'marks remain today.'} A separate request limit also applies. Shared across packs. Daily processing budget resets {new Date(usage.resetsAt).toLocaleString()}. {kind === 'grading' && 'Free trials also have a separate lifetime limit of two marks. '}
        Budget includes the course material read by AI and its answer, so longer material uses more. About {data.tokens.remaining.toLocaleString()} of {data.tokens.limit.toLocaleString()} tokens remain; this does not guarantee a particular number of answers. Short-term limits also apply.</p>
    </details>;
}
